"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isBrowser_1 = require("./isBrowser");
var IsTiendeo = function (domain) {
    if (domain === void 0) { domain = ""; }
    if (!domain && !isBrowser_1.default()) {
        return false;
    }
    var correctDomain = domain ? domain : window.location.hostname;
    return correctDomain.indexOf("tiendeo") !== -1;
};
exports.default = IsTiendeo;
//# sourceMappingURL=isTiendeo.js.map